import React from "react";

import {Alert} from 'react-bootstrap'

import LoadingComponent from "./LoadingComponent";
import AccessDeniedPartial from "../partials/AccessDeniedPartial";
import PdfPreviewPartial from "../partials/PdfPreviewPartial";

const ManageFilePreviewComponent = ({status, extension, file, language, id}) => {
  console.log(extension)
  let view = <LoadingComponent />;
  if(status === false){
    view = <AccessDeniedPartial />
  }
  else{
    if(extension === "pdf"){
      view = <PdfPreviewPartial fileHash={file} id={id} language={language} />
    }
    else{
      view = <p className="no-preview">Aby uzyskać dostęp do pliku, pobierz go za pomocą przycisku pobierania.</p>
    }
  }


  return(
    <React.Fragment>{view}</React.Fragment>
  )

}

export default ManageFilePreviewComponent;